import axiosClient from "utils/axios";
import { ApiList, ApiOptionList, ApiResponse } from "../../../types/api.types";
import {
  AddClientRequest,
  Client,
  UpdateClientRequest,
} from "features/Clients/types/client.types";

export const getClients = async ({
  page,
  limit,
  search,
}: {
  page?: number;
  limit?: number;
  search?: string;
} = {}) => {
  try {
    const response = await axiosClient.get<ApiResponse<ApiList<Client[]>>>(
      "/clients",
      {
        params: {
          page,
          limit,
          search: search?.trim() || undefined,
        },
      },
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching Clients : ", err);
    throw err;
  }
};

export const getClientOptions = async ({
  query,
  limit,
  page,
}: {
  query?: string;
  limit?: number;
  page?: number;
}) => {
  try {
    const response = await axiosClient.get<ApiResponse<ApiOptionList>>(
      `/clients/options`,
      {
        params: {
          query,
          limit,
          page,
        },
      },
    );

    return response.data;
  } catch (err) {
    console.warn("Error fetching Client Options : ", err);
    throw err;
  }
};

export const createClient = async (payload: AddClientRequest | FormData) => {
  try {
    const response = await axiosClient.post<ApiResponse<Client>>(
      "/clients",
      payload,
    );
    return response.data;
  } catch (err) {
    console.warn("Error creating Client : ", err);
    throw err;
  }
};

export const updateClient = async (
  id: number,
  payload: UpdateClientRequest | FormData,
) => {
  try {
    const response = await axiosClient.put<ApiResponse<Client>>(
      `/clients/${id}`,
      payload,
    );
    return response.data;
  } catch (err) {
    console.warn("Error updating Client : ", err);
    throw err;
  }
};

export const getClient = async (id: number) => {
  try {
    if (!Number.isInteger(id) || id <= 0) {
      throw new Error("Invalid ID");
    }
    const response = await axiosClient.get<ApiResponse<Client>>(
      `/clients/${id}`,
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching Client : ", err);
    throw err;
  }
};

export const deleteClient = async (id: number) => {
  try {
    const response = await axiosClient.delete<ApiResponse<Client>>(
      `/clients/${id}`,
    );
    return response.data;
  } catch (err) {
    console.warn("Error deleting Client : ", err);
    throw err;
  }
};
